import React, { useEffect, useState } from "react";
import logo from '../assets/logo.png'

export default function AppPaymentSuccess() {
    const [lang, setLang] = useState("fr"); // default French


    const openApp = () => {
        // const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        // if (isIOS) {
        window.location.href = "diaba://payment-success";
        // } else {
        //     const intentUrl =
        //         "intent://payment-success#Intent;scheme=diaba;package=com.diaba.ecommerce;end;";
        //     window.location.href = intentUrl;
        // }
    };


    useEffect(() => {
        openApp()
    }, [])



    const content = {
        fr: {
            title: "Paiement Réussi",
            message: "Vous serez redirigé(e) vers l'application Diaba sous peu.",
            sub: "Vous n'êtes pas redirigé(e) ?",
            btn: "Cliquez ici pour revenir à l'application Diaba",
        },
        en: {
            title: "Payment Successful",
            message: "You’ll be redirected to the Diaba app shortly.",
            sub: "Not redirected? ",
            btn: "Click here to return to the Diaba app",
        },
    };

    const t = content[lang];

    return (
        <div className="payment-wrapper">


            <div className="payment-card">
                <div className="lang-switch">
                    <button
                        className={lang === "fr" ? "active" : ""}
                        onClick={() => setLang("fr")}
                    >
                        FR
                    </button>
                    <button
                        className={lang === "en" ? "active" : ""}
                        onClick={() => setLang("en")}
                    >
                        EN
                    </button>
                </div>
                <img
                    src={logo}   // replace with your logo path
                    alt="Logo"
                    className="logo"
                />

                <div className="success-icon">✓</div>

                <h1>{t.title}</h1>
                <p className="main-text">{t.message}</p>
                <p className="sub-text">{t.sub}</p>

                <button className="home-btn" onClick={openApp}>{t.btn}</button>
            </div>
        </div>
    );
}
